import { Channel } from 'types/Asset';

export type ChannelsStore = {
    channels?: Channel[];
    error?: boolean;
    loading?: boolean;
    isFetching?: boolean;
};

const initialState: ChannelsStore = { isFetching: false };

export type ChannelsActions =
    | 'STORE_CHANNELS'
    | 'CHANNELS_LOADING'
    | 'CHANNELS_LOAD_ERROR'
    | 'CHANNELS_INTERRUPTED'
    | 'CHANNELS_FETCHING_START'
    | 'CHANNELS_FETCHING_END'
    | 'CLEAR_CHANNELS';

export type ChannelAction = {
    type: ChannelsActions;
    payload: Channel[];
};

export const channelsAction = (type: ChannelsActions, payload?: Channel[]): ChannelAction => ({
    type,
    payload,
});

// eslint-disable-next-line default-param-last
export default (state: ChannelsStore = initialState, action: ChannelAction): ChannelsStore => {
    switch (action.type) {
        case 'CHANNELS_FETCHING_START':
            return {
                ...state,
                isFetching: true,
            };
        case 'CHANNELS_FETCHING_END':
            return {
                ...state,
                isFetching: false,
            };
        case 'STORE_CHANNELS':
            return {
                ...state,
                ...{
                    channels: action.payload,
                    error: null,
                    loading: false,
                    isFetching: false,
                },
            };
        case 'CHANNELS_LOADING':
            return {
                ...state,
                ...{
                    channels: state.channels,
                    error: null,
                    loading: true,
                },
            };
        case 'CHANNELS_LOAD_ERROR':
            return {
                ...state,
                ...{
                    channels: null,
                    error: true,
                    loading: false,
                    isFetching: false,
                },
            };
        case 'CHANNELS_INTERRUPTED':
            return initialState;
        case 'CLEAR_CHANNELS':
            return initialState;
        default:
            return state;
    }
};
